import React from 'react';
import { useTranslation } from 'react-i18next';

const NewsVisibleDomains = ({ value }) => {
    const { t } = useTranslation();
    if (!Array.isArray(value) || value.length === 0) {
        return <span>{t('news.noDomains')}</span>;
    }

    return <span>{value.join(', ')}</span>;
};

export default NewsVisibleDomains;
